export function arrangeMasonry(images, count, width, gap) {
  const columns = Array.from({ length: count }, () => []);
  const heights = Array(count).fill(0);
  const columnWidth = (width - gap * (count - 1)) / count;
  // Place tall photographs first to keep the final column heights balanced.
  const ordered = images.map((image, index) => ({ ...image, index }))
    .sort((a, b) => b.height / b.width - a.height / a.width || a.index - b.index);
  for (const image of ordered) {
    const column = heights.indexOf(Math.min(...heights));
    columns[column].push(image);
    heights[column] += columnWidth * image.height / image.width + gap;
  }
  // Keep each column in the original editorial order.
  return columns.map(column => column.sort((a, b) => a.index - b.index));
}
